/* RETTERBOX max-order-qty.js — soft per-variant max-order-quantity clamp.
 *
 * Source of truth: custom.max_order_qty (number_integer, on the VARIANT).
 * Rule (single products AND bundles alike): clamp the cart LINE quantity of the
 * variant to its max_order_qty. For a 24er bundle with max 1 that means "max 1
 * pack" — no per-unit multiplication.
 *
 * The limit travels per line in the `_max_qty` property (set at add-time) with a
 * page-load fallback map in window.RB_MAXQTY.cart (snippets/max-order-qty-config).
 *
 * Enforcement: a fetch wrapper runs clampCart() after every /cart/add|change|update.js
 * mutation, resetting any over-limit line via /cart/update.js (by item.key). A queue
 * serializes passes and each pass loops to a FIXPOINT re-reading a no-store /cart.js,
 * so rapid repeated clicks (whose adds land mid-clamp) can't leave a line above max.
 * Soft UX limit — bypassable via direct AJAX/permalink; hard enforcement needs a
 * Checkout Validation Function (Plus) or an order-limit app reading the same metafield.
 */
(function () {
  'use strict';

  var CFG = window.RB_MAXQTY = window.RB_MAXQTY || {};
  CFG.cart = CFG.cart || {};

  var origFetch = window.fetch.bind(window);

  function getCart() {
    // no-store: never clamp against a cached /cart.js (that let rapid clicks slip through)
    return origFetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }
  function maxFor(item) {
    var v = item.properties && item.properties._max_qty;
    if (v == null || v === '') v = CFG.cart[item.variant_id];
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }
  function notify(item, max) {
    var msg = 'Max. ' + max + ' × „' + (item.product_title || 'Artikel') + '“ pro Bestellung';
    if (window.RB_showToast) window.RB_showToast(msg);
    else document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: msg } }));
  }

  // One clamp pass, looped to a fixpoint: keep resetting over-limit lines until a
  // fresh read shows none (catches adds that land between read and update).
  function clampPass(state) {
    state = state || { changed: false, hit: null, iters: 0 };
    if (state.iters >= 12) return Promise.resolve(state);   // safety backstop
    return getCart().then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (it) {
        var max = maxFor(it);
        if (max > 0 && it.quantity > max) {
          updates[it.key] = max;
          if (!state.hit) state.hit = { title: it.product_title, max: max };
        }
      });
      if (!Object.keys(updates).length) return state;       // stable → done
      state.changed = true; state.iters++;
      return origFetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return clampPass(state); });     // re-verify
    });
  }

  // Single-flight queue: every caller gets a promise that resolves after a full pass.
  var queue = Promise.resolve();
  function clampCart(andBroadcast) {
    if (andBroadcast === undefined) andBroadcast = true;
    queue = queue.then(function () { return clampPass(); }).then(function (state) {
      if (state && state.changed) {
        if (state.hit) notify({ product_title: state.hit.title }, state.hit.max);
        if (andBroadcast) {
          return getCart().then(function (c) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
            return c;
          });
        }
      }
      return null;
    }).catch(function (err) { console.error('[RB MaxQty] clamp failed', err); });
    return queue;
  }
  window.RB_clampCart = clampCart;
  window.RB_clampCartQuiet = function () { return clampCart(false); };

  // ── fetch wrapper: after any cart mutation, clamp (clamp itself uses origFetch) ──
  var CART_MUT = /\/cart\/(add|change|update)(\.js)?(\?|$)/i;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (typeof input === 'object' && input && input.method) || 'GET';
    var p = origFetch(input, init);
    if (CART_MUT.test(url) && /post/i.test(method)) {
      p.then(function () { clampCart(); }, function () {});
    }
    return p;
  };

  // Self-heal on load (covers permalinks / pre-existing over-limit lines).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { clampCart(); });
  } else {
    clampCart();
  }
})();
